module.exports = __webpack_public_path__ + "img/language.7e199adf.svg";